import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.hasMultipleClinicalProducts)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass([_ctx.getProductPillClass(_ctx.productId), "pill"])
      }, _toDisplayString(_ctx.getProductFullName(_ctx.productId)), 3 /* TEXT, CLASS */))
    : _createCommentVNode("v-if", true)
}